import React from 'react';

export default function UnmatchedRoute() {
  return (
    <div>
      <h1>404 You shouldnt be here.</h1>
    </div>
  );
}
